export default __webpack_public_path__ + "static/media/chat-info.4bd5c8be.svg";